const getTaxonPermalink = (partialSpreeTaxon)=>{
    return partialSpreeTaxon.attributes.permalink;
};
export default getTaxonPermalink;
